// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"SubjectOutcomesSection_scrollContainer__1QfwV","cardGradient":"SubjectOutcomesSection_cardGradient__hgDMj"};